/* eslint-disable max-params -- legacy placeholder module */
/* eslint-disable react/prop-types -- legacy placeholder module */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import { composeModules } from 'holocron';
import { IntlProvider } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import {
  getSelectedProduct, CARD_PRODUCT, getProductsByTypes, PERSONAL_SAVINGS_ACCOUNT,
} from '@americanexpress/product-ducks';

import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { testAccountToken, testProductsList } from '../../mock/accountMock';
import CompletionPage from './CompletionPage';
import LandingPage from './LandingPage';
import UploadPage from './UploadPage';

const createGuid = () => {
  if (typeof globalThis !== 'undefined' && globalThis.crypto && globalThis.crypto.randomUUID) {
    return globalThis.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const DocumentCenter = ({
  languageData,
}) => {
  const [submitResponse, setSubmitResponse] = useState(null);
  const [showLandingPage, setShowLandingPage] = useState(true);
  const [docTypeId, setDocTypeId] = useState('');
  const [formHiddenData, setFormHiddenData] = useState({});
  const [fieldsData, setFieldsData] = useState({});
  const [validationData, setValidationData] = useState({});
  const [isValidForm, setIsValidForm] = useState(false);
  const [accountSelection, setAccountSelection] = useState(null);
  const [kycFlow, setKycFlow] = useState('NEVER_KYC');

  const [downloadProgress, setDownloadProgress] = useState([]);

  const [accountListStatus, setAccountListStatus] = useState('default');
  const [scrollIntoSelect, setScrollIntoSelect] = useState(null);
  const [scrollIntoForm, setScrollIntoForm] = useState(null);
  const [guid, setGuid] = useState(null);

  const accountToken = useSelector((state) => (process.env.NODE_ENV === 'development' ? testAccountToken : getSelectedProduct(state))) || '';
  const [previewData, setPreviewData] = useState({
    documentId: null,
    fileId: null,
    fileName: null,
    fileSize: null,
    idx: null,
  });

  const {
    selectedProduct,
    ...productData
  } = useSelector((state) => (process.env.NODE_ENV === 'development' ? testProductsList : getProductsByTypes(state)));
  const productOrder = [];
  let productList = {};
  [PERSONAL_SAVINGS_ACCOUNT, CARD_PRODUCT].forEach((type) => {
    const { productsOrder, productsList } = productData[type];
    productOrder.push(...productsOrder);
    productList = {
      ...productList,
      ...productsList,
    };
  });

  // const resolvedLocale = locale || 'en-US';
  const dispatch = useDispatch();
  const locale = useSelector((state) => state.getIn(['intl', 'activeLocale']));
  useEffect(() => {
    dispatch(loadLanguagePack('axp-document-center', { fallbackLocale: 'en-US' }));
  }, [dispatch, locale]);
  const labels = {
    accountNumber: languageData?.accountNumberLabel || 'Select Account',
    back: languageData?.backLabel || 'Go Back',
    upload: languageData?.uploadNewDocs || 'Upload',
  };
  const handleDocTypeRes = (docType, intentName) => {
    setDocTypeId(docType);
    setKycFlow(intentName || 'NEVER_KYC');
    setFormHiddenData({});
    setFieldsData({});
    setValidationData({});
  };
  const handleFormChange = (res) => {
    const isValidFormValue = res.isValidForm;
    if (isValidFormValue) {
      setScrollIntoForm(null);
    }
    setFormHiddenData(res.formHiddenData);
    setFieldsData(res.fieldsData);
    setIsValidForm(res.isValidForm);
  };

  const handleResponseReset = () => {
    setSubmitResponse(null);
  };

  const handleSubmitRes = (res) => {
    setSubmitResponse(res);
    setPreviewData({
      documentId: null,
      fileId: null,
      fileName: null,
      fileSize: null,
      idx: null,
    });
  };

  const handleLandingPage = (bool) => {
    if (!bool) {
      handleResponseReset();
    }
    setShowLandingPage(bool);
    setDocTypeId('');
    setFormHiddenData({});
    setFieldsData({});
    setValidationData({});
    setScrollIntoSelect(null);
    setScrollIntoForm(null);
    setAccountSelection(null);
  };

  const handleDownloadProgress = (progress) => {
    const clonedDP = [...downloadProgress];
    const fIndex = clonedDP.findIndex((f) => f.fileId === progress.fileId);
    if (fIndex > -1) {
      clonedDP[fIndex] = progress;
    } else {
      clonedDP.push(progress);
    }
    setDownloadProgress(clonedDP);
  };

  const handleFilePreview = (documentId, fileId, fileName, fileSize, idx, processId) => {
    setPreviewData({
      ...previewData,
      documentId,
      fileId,
      fileName,
      fileSize,
      idx,
      processId,
    });
  };

  /* istanbul ignore next */
  const handleSubmitCheck = () => {
    if (accountSelection === null) {
      // docTypeSelect
      setAccountListStatus('error');
    } else if (docTypeId === '') {
      setScrollIntoSelect(scrollIntoSelect + 1);
    } else if (!isValidForm) {
      setScrollIntoForm(scrollIntoForm + 1);
    } else if (docTypeId !== '' && isValidForm) {
      setScrollIntoForm(null);
      setScrollIntoSelect(null);
    }
  };

  const onDropdownChange = (e, isRequired, validationMsg) => {
    if (e === 'select') {
      setAccountSelection(null);
    } else {
      const parsedE = JSON.parse(e);
      setAccountSelection({
        ...accountSelection,
        accountToken: parsedE.accountToken,
        accountTypeLabel: parsedE.accountTypeLabel,
        type: parsedE.type,
      });
      /* istanbul ignore next */
      setValidationData({
        ...validationData,
        isValidaccountToken: isRequired && (parsedE.accountToken === 0) ? validationMsg || 'Required field' : '',
        isValidaccountTypeLabel: isRequired && (parsedE.accountTypeLabel === 0) ? validationMsg || 'Required field' : '',
        isValidlineOfBusinessType: isRequired && (parsedE.type === 0) ? validationMsg || 'Required field' : '',
      });
      setGuid(createGuid());
      setAccountListStatus('default');
    }
  };

  const isSubmitSuccess = submitResponse !== null && submitResponse.status.statusCode === '60200';

  const renderCurrentView = () => {
    if (isSubmitSuccess && !showLandingPage) {
      return <CompletionPage onDone={() => handleLandingPage(true)} />;
    }
    if (showLandingPage) {
      return (
        <LandingPage
          handleLandingPage={handleLandingPage}
          accountToken={accountToken}
          filePreview={handleFilePreview}
          downloadProgress={downloadProgress}
          labels={labels}
        />
      );
    }
    return (
      <UploadPage
        labels={labels}
        handleLandingPage={handleLandingPage}
        productList={productList}
        accountSelection={accountSelection}
        accountListStatus={accountListStatus}
        accountToken={accountToken}
        onDropdownChange={onDropdownChange}
        languageData={languageData}
        locale={locale}
        docTypeId={docTypeId}
        handleDocTypeRes={handleDocTypeRes}
        handleResponseReset={handleResponseReset}
        scrollIntoSelect={scrollIntoSelect}
        guid={guid}
        handleFormChange={handleFormChange}
        scrollIntoForm={scrollIntoForm}
        formHiddenData={formHiddenData}
        fieldsData={fieldsData}
        isValidForm={isValidForm}
        handleSubmitCheck={handleSubmitCheck}
        handleSubmitRes={handleSubmitRes}
        handleFilePreview={handleFilePreview}
        downloadProgress={downloadProgress}
        previewData={previewData}
        handleDownloadProgress={handleDownloadProgress}
        kycFlow={kycFlow}
      />
    );
  };

  return (
    <IntlProvider locale={locale} defaultLocale="en-US" messages={languageData}>
      <div className="container-responsive margin-3-tb margin-auto-lr">
        {renderCurrentView()}
      </div>
    </IntlProvider>
  );
};
DocumentCenter.defaultProps = {
  languageData: null,
};

DocumentCenter.propTypes = {
  languageData: PropTypes.shape({}),
};

export const loadModuleData = async ({ store: { dispatch } }) => {
  await dispatch(loadLanguagePack('axp-document-center', { fallbackLocale: 'en-US' }));
  await dispatch(
    composeModules([
      { name: 'axp-document-upload-history' },
      { name: 'axp-document-repositories' },
      { name: 'axp-document-upload-form' },
      { name: 'axp-document-upload-preview' },
      { name: 'axp-document-uploader' },
    ])
  );
};

DocumentCenter.holocron = {
  name: 'axp-document-center',
  loadModuleData,
};
export { DocumentCenter as UnwrappedDocumentCenter };
export default oneAppModuleWrapper('axp-document-center')(DocumentCenter);
/* eslint-enable max-params */
/* eslint-enable react/prop-types */
